import { createContext } from "react";
import { AppRestServicesType } from "../../services/appServices";
export const ServicesContext = createContext<AppRestServicesType | null>(null);
